export default __webpack_public_path__ + "static/media/lab-activity-02.f5d6f403.jpg";